import React from "react"
import { Link } from "gatsby"
import styled from 'styled-components'

class MobileMenu extends React.Component { 


    render() {
        return (
            <Container>
                <Wrap>
                    <MenuList>
                    <li> 
                        <StyledLink to="/">
                            Moscow
                        </StyledLink>
                    </li>
                    <li> 
                        <StyledLink to="/attractions/">
                            Attractions
                        </StyledLink>
                    </li>
                    <li> 
                        <StyledLink to="/hotels/">
                            Hotels
                        </StyledLink>
                    </li>
                    <li> 
                        <StyledLink to="/moscow-strip-clubs/">
                            Strip Clubs
                        </StyledLink>
                    </li>
                    <li> 
                        <StyledLink to="/moscow-erotic-massage/">
                            Erotic Massage
                        </StyledLink>
                    </li>
                    <li> 
                        <StyledLink to="/moscow-nightclubs/">
                            Nightlife
                        </StyledLink>
                    </li>
                    <li> 
                        <StyledLink to="/best-restaurants-moscow/">
                            Restaurants
                        </StyledLink>
                    </li>
                    </MenuList>
                </Wrap>
            </Container>
            
        )
    }
}

const Container = styled.div`
    position: absolute;
    z-index: 999999;
    background: #fff;
    width: 100%;
    padding: 10px 10px 20px;
`;

const Wrap = styled.div`
`;
const MenuList = styled.ul`
    margin: 0;
    padding: 0;
    li {
        list-style: none;
        border-bottom: 1px solid #EDEDED;
        line-height: 0;
        a {
            padding: 5px 0;
            line-height: 1.8;
            display: block;
        }
    }
`;
const StyledLink = styled(Link)`
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
`

export default MobileMenu